module.exports = __webpack_public_path__ + "a407bf730b88780a585d7c7e68d242e3.jpg";